import * as dayjs from 'dayjs';
import { PlayerMix } from './player-mix.model';
import { PlayerInstance } from './player-instance.model';
import { Uuid } from '@hidat/huijs-common';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';
import { PlayerSessionInterface } from '@splixer/common';
import {
  PlayerItemToPlay,
  MediaToPlay,
  SegmentToPlay,
  ShowToPlay,
} from './media-to-play.model';
import { SteeringWheelPaths } from './steering-wheel.model';

export class LoadErrorInfo {
  @Expose({ name: 'required' })
  required = 0;
  @Expose({ name: 'available' })
  available = 0;
}

export class SkipStatus {
  @Expose({ name: 'can_skip' })
  canSkip = false;
  @Expose({ name: 'can_skip_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  canSkipAt: dayjs.Dayjs | undefined = undefined;
  @Expose({ name: 'count' })
  count = 0;
}

/**
 * Extension of the Playback session that includes all the 'includes' that the player uses.
 */
export class PlayerSession implements PlayerSessionInterface {
  @Expose()
  sessionId: Uuid | undefined = undefined;
  @Expose()
  instanceId: Uuid | undefined = undefined;
  @Expose()
  listenerId: Uuid | undefined = undefined;
  @Expose()
  sessionPathId: Uuid | undefined = undefined;
  @Expose()
  status = 100;

  @Expose()
  sessionError: number | undefined = undefined;
  @Expose({ name: 'load_error_info' })
  @Type(() => LoadErrorInfo)
  loadErrorInfo: LoadErrorInfo | undefined = undefined;

  @Expose()
  @Type(() => SkipStatus)
  skipStatus: SkipStatus | undefined;

  @Expose()
  @Type(() => PlayerMix)
  _currentMix: PlayerMix | undefined = undefined;
  //@Expose({name:'current_state'})
  //currentState: AnyHash = {};
  @Expose()
  @Type(() => MediaToPlay)
  _mediaToPlay: MediaToPlay[] = [];
  @Expose()
  @Type(() => PlayerItemToPlay, {
    discriminator: {
      property: '_type',
      subTypes: [
        { value: ShowToPlay, name: 'ShowToPlay' },
        { value: SegmentToPlay, name: 'SegmentToPlay' },
        { value: MediaToPlay, name: 'MediaToPlay' },
      ],
    },
  })
  _itemsToPlay: PlayerItemToPlay[] = [];

  @Expose()
  @Type(() => PlayerInstance)
  _instance: PlayerInstance | undefined = undefined;

  @Expose()
  @Type(() => SteeringWheelPaths)
  _altPaths: SteeringWheelPaths | undefined;
  @Expose()
  @Type(() => PlayerMix)
  _relatedContent: PlayerMix[] | undefined = undefined;
}
